jQuery(document).ready(function(){
    // move snackCollectionsContainer on my-orders page based on browser width
    if(jQuery('body').hasClass('my-orders') || jQuery('body').hasClass('payment-details')) {
        const statusContainer = jQuery('.status-container');
        const statusOrders = jQuery('.status-orders');
        const snackCollectionsContainer = jQuery('.snack-collections-container');

        if (jQuery(window).width() < 768) {
            snackCollectionsContainer.insertAfter(statusContainer);
        } else {
            snackCollectionsContainer.insertAfter(statusOrders);
        }

        jQuery(window).on('resize', function() {
            let windowWidth = jQuery(window).width();
            if (windowWidth < 768) {
                snackCollectionsContainer.insertAfter(statusContainer);
            } else {
                snackCollectionsContainer.insertAfter(statusOrders);
            }
        });
  
        initializeCollections();
    }
});

function initializeCollections()
{
    // only on my-orders page
    if(jQuery('body').hasClass('my-orders') || jQuery('body').hasClass('payment-details')) {
        jQuery('<div class="quantity-nav"><div class="quantity-button quantity-up">+</div><div class="quantity-button quantity-down">-</div></div>').insertAfter('.quantity input');

        // calculate total price 
        
        //let totalModalPrice = document.getElementById('totalModalPrice').innerHTML;
        
        jQuery('.quantity').each(function() {
            var spinner = jQuery(this),
                            input = spinner.find('input[type="number"]'),
                            btnUp = spinner.find('.quantity-up'),
                            btnDown = spinner.find('.quantity-down'),
                            min = input.attr('min'),
                            max = input.attr('max');
            
            btnUp.click(function() {
                let totalModalPrice = document.getElementById('singlePriceModal').innerHTML;
                let newTotalModalPrice = parseFloat(totalModalPrice).toFixed(2);
        
                var oldValue = parseFloat(input.val());
                var taxFloatVal;
                var taxPct = jQuery("input[name='tax_pct']").val();
                if (oldValue >= max) {
                    var newVal = oldValue;
                } else {
                    var newVal = oldValue + 1;
                    if( taxPct > 0 )
                    {
                        taxFloatVal = parseFloat( taxPct * parseFloat(document.getElementById("singlePriceModal").innerHTML) * newVal).toFixed(2);

                        document.getElementById("taxValue").innerHTML = taxFloatVal;
                    }
                    else
                    {
                        taxFloatVal = 0;
                        document.getElementById("taxValue").innerHTML = '--';
                    }
                    let basePrice = parseFloat(newTotalModalPrice * newVal).toFixed(2);
                    let totalPrice = parseFloat(taxFloatVal) + parseFloat(basePrice);
                    document.getElementById("totalModalPrice").innerHTML = parseFloat(totalPrice).toFixed(2);
                    
                }
                spinner.find("input").val(newVal);
                spinner.find("input").trigger("change");
            });
        
            btnDown.click(function() {
                let totalModalPrice = document.getElementById('singlePriceModal').innerHTML;
                let newTotalModalPrice = parseFloat(totalModalPrice).toFixed(2);
                var oldValue = parseFloat(input.val());
                var taxFloatVal;
                var taxPct = jQuery("input[name='tax_pct']").val();
                if (oldValue <= min) {
                    var newVal = oldValue;
                } else {
                    var newVal = oldValue - 1;
                    if( taxPct > 0 )
                    {
                        taxFloatVal = parseFloat( taxPct * parseFloat(document.getElementById("singlePriceModal").innerHTML) * newVal).toFixed(2);

                        document.getElementById("taxValue").innerHTML = taxFloatVal;
                    }
                    else
                    {
                        taxFloatVal = 0;
                        document.getElementById("taxValue").innerHTML = '--';
                    }
                    let basePrice = parseFloat(newTotalModalPrice * newVal).toFixed(2);
                    let totalPrice = parseFloat(taxFloatVal) + parseFloat(basePrice);
                    document.getElementById("totalModalPrice").innerHTML = parseFloat(totalPrice).toFixed(2);
                }
                spinner.find("input").val(newVal);
                spinner.find("input").trigger("change");
            });
        
        
            let inputModal = document.getElementById('quantityCollection');
        
            inputModal.addEventListener('change', updateValue);
        
            function updateValue(e) {
                
                let qtyVal = document.getElementById('quantityCollection').value;
        
                let newQtyVal = parseFloat(qtyVal);
        
                let productPriceStatic = document.querySelector('.product-price');
        
                productPriceStatic.click();
        
                
            }
        
        
        
        });
        
        let accountCheckoutModal = document.querySelector('.accountCheckoutModal');
        
        jQuery('#editShippingAddressModal').on('show.bs.modal', function() {
            shippingModalActive();
        });

        jQuery('#editShippingAddressModal').on('hide.bs.modal', function() {
            shippingModalInactive()        
        });

        jQuery('#addCard').on('show.bs.modal', function() {
            shippingModalActive();
        });

        jQuery('#addCard').on('hide.bs.modal', function() {
            shippingModalInactive()        
        });

        initStripe();
        
        function shippingModalActive() {
            accountCheckoutModal.classList.add('shipping-open');
            jQuery('.modal-backdrop').css('display', 'none');
        }
        
        function shippingModalInactive() {
            accountCheckoutModal.classList.remove('shipping-open');
            jQuery('.modal-backdrop').css('display', 'block');
        }

        jQuery('#accountCheckoutModal').on('show.bs.modal', function (event) {
            let btn = event.relatedTarget;

            let code = btn.dataset.code;
            let title = btn.dataset.name;
            let size = btn.dataset.size;
            let img = btn.dataset.featuredimage;
            let postId = btn.dataset.postid;
            let price = btn.dataset.price;
            let preorderDate = btn.dataset.preorderdate;
            let fulfillmentName = btn.dataset.fulfillmentname;

            jQuery("#accountCheckoutModal #quantityCollection").val( 1 );
            jQuery("#accountCheckoutModal input[name='code']").val( code );
            jQuery("#accountCheckoutModal input[name='size']").val( size );
            jQuery("#accountCheckoutModal input[name='title']").val( title );
            jQuery("#accountCheckoutModal input[name='postId']").val( postId );
            jQuery("#accountCheckoutModal input[name='price']").val( price );
            jQuery("#accountCheckoutModal input[name='preorder_date']").val( preorderDate );
            jQuery("#accountCheckoutModal input[name='featured_image']").val( img );
            jQuery("#accountCheckoutModal input[name='fulfillment_name']").val( fulfillmentName );
            jQuery("#accountCheckoutModal #singlePriceModal").text( price );
            jQuery("#accountCheckoutModal #totalModalPrice").text( price );

            jQuery("#accountCheckoutModal #featured-image").attr( 'src', img );
            jQuery("#accountCheckoutModal #featured-image").attr( 'alt', title );
            jQuery("#accountCheckoutModal #product-title").text( title );

            jQuery(".checkoutCardBtn").on("click", function(evt){
                let selectedCardBtn = evt.currentTarget;
                jQuery('.icon-card-saved').addClass("d-none");
                jQuery(selectedCardBtn).find('.icon-card-saved').removeClass("d-none");
                jQuery("input[name='source']").val( selectedCardBtn.dataset.cardid );
            });
        });
        
        var hash = decodeURI(jQuery(location).attr('hash')).substring(1);

        if( !hash )
        {
            const urlParams = new URLSearchParams( window.location.search );
            if( urlParams.get('promo') != null )
            {
                hash = urlParams.get('promo');
            }
        }

        if( hash )
        {
            if( jQuery( "[data-target='#accountCheckoutModal'][data-slug='"+ hash +"']" ).length )
            {
                jQuery( "[data-target='#accountCheckoutModal'][data-slug='"+ hash +"']" ).click();
            }
        }
    } 

}